export * from './upload-photo.component';
export * from './select-products.component';
export * from './load-product.component';
export * from './order-completed.component';
export * from './campionario-completed.component';
export * from './select-dimensions.component';
export * from './preview.component';
export * from './cart.component';
export * from './checkout.component';
export * from './checkout.campionario.component';
export * from './pagecrop.component';
export * from './no-content.component';
export * from './btnToggle.component';
export * from './similFancy.component';
export * from './slide-parameter.component';

export * from 'angulartics2';




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/index.ts